import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageProvider";
import logoUrl from "../assets/growthwise-logo-primary-education.svg";

/**
 * The GrowthWise wordmark from the brand kit. It is outlined artwork with
 * a custom W, so it must be used as supplied rather than retyped.
 */
export const BrandLink = () => {
  const { t, path } = useLanguage();
  return (
    <Link to={path("/")} className="gw-logo">
      <img
        className="gw-logo__image"
        src={logoUrl}
        alt={t("meta.siteName")}
        width={841}
        height={198}
      />
    </Link>
  );
};
